import React, { FC, useEffect } from 'react';

import cx from 'classnames';

import {
  filtersIsLoadingSelector,
  filtersSelector,
  tabFiltersIsLoadingSelector,
} from 'selectors/filterSlice.selectors';
import { useLazyV2GetFiltersQuery } from 'services/v2-overview-service/overviewService';
import { useAppSelector } from 'store';

import WithSkeletonLoader from 'components/with-skeleton-loader';

import s from './Sidebar.module.scss';
import CopyFilters from './copy-filters';
import Filters from './filters';
import SidebarSkeleton from './sidebar.skeleton';

interface SidebarProps {
  collapsed: boolean;
}

const Sidebar: FC<SidebarProps> = (props) => {
  const { collapsed } = props;

  const filtersIsLoading = useAppSelector(filtersIsLoadingSelector);
  const tabFiltersIsLoading = useAppSelector(tabFiltersIsLoadingSelector);
  const filters = useAppSelector(filtersSelector);

  const [getFilters] = useLazyV2GetFiltersQuery();

  const stringifiedFilters = JSON.stringify(filters);
  useEffect(() => {
    if (stringifiedFilters === 'null') {
      getFilters();
    }
  }, [stringifiedFilters, getFilters]);

  return (
    <div className={cx(s.wrapper, { [s.collapsed]: collapsed })}>
      <div className={s.filtersWrapper}>
        <WithSkeletonLoader
          isLoading={filtersIsLoading || tabFiltersIsLoading}
          skeletonLoader={<SidebarSkeleton />}>
          <Filters />
        </WithSkeletonLoader>
      </div>
      <CopyFilters />
    </div>
  );
};

export default Sidebar;
